import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vrnc945tth: FaireBrandEntity = {
  token: "b_vrnc945tth",
  type: "brand",
  name: "Little Miss PinkerBell",
  avatarUrl:
    "https://cdn.faire.com/fastly/5e3c37af6cdc86c5ffc122a493e724884ffad2337a231afaa93cbe0cee51d460.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/070319b1349502b327e4dce90819e063993110fab4239a02b4f0a6cc5dfcaeab.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5e3c37af6cdc86c5ffc122a493e724884ffad2337a231afaa93cbe0cee51d460.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/070319b1349502b327e4dce90819e063993110fab4239a02b4f0a6cc5dfcaeab.jpeg",
  location: "Staunton, VA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 3,
  isInsider: true,
  description:
    "“The World always seems brighter when you’ve just made something that wasn’t there before.”-Neil Gaimen\n\nMy goal as an artist is to use illustrations to capture the human experience: The joyous, the humorous, the struggles, the day to day, the heartbreak, and the healing. For me, illustrating helps me better understand the world. It provides a place for me to fight for the things I care about but in a way that is relatable. Faceless portraits allow the viewer to have a more personalized experience with the art. They can both insert themselves and the emotion they wish to see in the piece. \n​\nThrough art we can be the best versions of ourselves. While I do offer customized pieces, specifically with a focus on helping others overcome grief and infant loss, it is also important to me that my art and its messages are easily accessible and affordable. Therefore the majority of my artist time is spent largely on producing stickers, bookmarks, prints, and cards. I have found healing through art and humor  and I wish to share that with others. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.154Z",
    importedBy: "entity-db-cli",
  },
};
